import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";

import "./DownloadPage.css";

import androidImg from "../../images/Truslypay_imgs/android.png";
import iosImg from "../../images/Truslypay_imgs/apple.png";

import Bg from "../../images/bg/gardiant-bg.png";
import Downloadfooter from "../../components/footer/Downloadfooter.js";


const DownloadPage = () => {
  const handleDownload = (platform) => {
    if (platform === "android") {
      window.open(
        "https://play.google.com/store/apps/details?id=com.org.tigris",
        "_blank"
      );
    } else if (platform === "ios") {
      window.open(
        "https://apps.apple.com/us/app/tigrispay/id6754586181",
        "_blank"
      );
    }
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />

        {/* HERO SECTION */}
        <section
          className="page-title pos-rel bg_img download-hero-bg"
          style={{
            backgroundImage: `url(${Bg})`,
            padding: "80px 0",
          }}
        >
          <div className="container">
            <div className="page-title-wrap text-center">
              <h1 className="text-dark fw-bolder mt-5">
               Download the Tigris Pay app
              </h1>
              <p className="download-subtext text-dark">
                Fast. Secure. Global transfers at your fingertips.
              </p>
            </div>
          </div>
        </section>

        {/* MAIN DOWNLOAD SECTION */}
        <section
          className="pt-80 pb-130"
          style={{
            background: "linear-gradient(135deg, #ffffff, #f5f8ff)",
          }}
        >
          <div
            className="container"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "60px",
              flexWrap: "wrap",
            }}
          >

            {/* LEFT SIDE – NEW INLINE DESIGNED QR SECTION */}
            <div
              style={{
                flex: "1",
                minWidth: "330px",
                padding: "30px",
                background: "#fff",
                borderRadius: "20px",
              }}
            >
              {/* Badge */}
              <span
                style={{
                  display: "inline-block",
                  padding: "6px 14px",
                  background: "#ffd86b",
                  color: "#111",
                  fontSize: "13px",
                  fontWeight: "600",
                  borderRadius: "20px",
                  marginBottom: "18px",
                }}
              >
                AVAILABLE NOW
              </span>

              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: "700",
                  color: "#111",
                  marginBottom: "12px",
                }}
              >
                Instant Global Transfers
              </h3>

              <p
                style={{
                  fontSize: "16px",
                  color: "#555",
                  marginBottom: "25px",
                }}
              >
                Scan the QR codes to download the Tigris Pay App and start sending money
                worldwide securely and instantly.
              </p>

              {/* QR CONTAINER */}
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexWrap: "wrap",
                  marginTop: "25px",
                }}
              >
                {/* ANDROID CARD */}
                <div
                  style={{
                    flex: "1",
                    minWidth: "150px",
                    padding: "22px",
                    borderRadius: "20px",
                    background: "#fff",
                    border: "2px solid transparent",
                   backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      linear-gradient(135deg, #f9bb1d, #ffd86b, #f9bb1d)
    `,
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",
                    textAlign: "center",
                    boxShadow: "0 18px 35px rgba(249,187,29,0.25)",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#111",
                    }}
                  >
                    Google Play
                  </h3>

                  <img
                    src="/playstoreqr.png"
                    alt="Android QR"
                    style={{
                      width: "160px",
                      height: "160px",
                      margin: "12px auto",
                      display: "block",
                    }}
                  />

                  <button
                    onClick={() => handleDownload("android")}
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img src={androidImg} alt="Android Button" style={{width: "180px"}}  />
                  </button>
                </div>

                {/* IOS CARD */}
                <div
                  style={{
                    flex: "1",
                    minWidth: "150px",
                    padding: "22px",
                    borderRadius: "20px",
                    background: "#fff",
                    border: "2px solid transparent",
                             backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      linear-gradient(135deg, #f9bb1d, #ffd86b, #f9bb1d)
    `,
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",
                    textAlign: "center",
                         boxShadow: "0 18px 35px rgba(249,187,29,0.25)",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#111",
                    }}
                  >
                    App Store
                  </h3>

                  <img
                    src="/iphoneqr.png"
                    alt="iOS QR"
                    style={{
                      width: "160px",
                      height: "160px",
                      margin: "12px auto",
                      display: "block",
                    }}
                  />

                  <button
                    onClick={() => handleDownload("ios")}
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img src={iosImg} alt="iOS Download Button" style={{width: "180px"}} />
                  </button>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE – APP IMAGE */}
            <div
              style={{
                flex: "1",
                minWidth: "300px",
                textAlign: "center",
              }}
            >
              <img
                src="/appmoc.png"
                alt="TigrisPay App"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  borderRadius: "25px",
                }}
              />
            </div>
          </div>
        </section>

        <Downloadfooter />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default DownloadPage;
